module.exports = __webpack_public_path__ + "static/img/2.f92e114.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mission/2.png
// module id = +jKi
// module chunks = 0